import Vue from 'vue'
import Router from 'vue-router'
import PageDashboard from '../pages/Dashboard.vue'
// import PageResultOverall from '../pages/result/Overall.vue'
import PageComponents from '../pages/Components.vue'
import PageVehicles from '../pages/Vehicles.vue'

// Wrapper
// import PageWrapper from '../components/shell/Wrapper.vue'

// find target / result
import PageResultRecentLocation from '../pages/result/RecentLocation.vue'
// for astro only
import PageResultRecentLocationAstro from '../pages/result/RecentLocationAstro.vue'
import PageResultApplicationUsage from '../pages/result/ApplicationUsage.vue'
import PageResult from '../pages/result/Result.vue'
// import PageResultHistoryApp from '../pages/result/HistoryApp.vue'
import PageResultHistoryBrowsing from '../pages/result/HistoryBrowsing.vue'
import PageResultHistoryLocation from '../pages/result/HistoryLocation.vue'
import PageResultPossibleLocation from '../pages/result/PossibleLocation.vue'
import PageResultAerialLog from '../pages/result/AerialLog.vue'
import PageResultSignalStatus from '../pages/result/SignalStatus.vue'
import PageResultDeviceHistory from '../pages/result/DeviceHistory.vue'
import PageResultTetheredDevices from '../pages/result/TetheredDevices.vue'
import PageResultProfile from '../pages/result/Profile.vue'
import PageResultPredictionNickname from '../pages/result/PredictionNickname.vue'
import PageResultVehicles from '../pages/result/Vehicles.vue'
import PageResultMarketplace from '../pages/result/Marketplace.vue'
import PageResultTravel from '../pages/result/Travel.vue'
// import PageResultHealthAlert from '../pages/result/HealthAlert.vue'
import PageTravelHistoryResult from '../pages/result/TravelHistoryResult.vue'
import PageResultEtilang from '../pages/result/Etilang.vue'
import PageResultBankAccount from '../pages/result/BankAccount.vue'
import PageResultPersonalIdentity from '../pages/result/PersonalIdentity.vue'
// auth
import PageLogin from '../pages/auth/Login.vue'
import PageForgotPassword from '../pages/auth/ForgotPassword.vue'
import PageResetPassword from '../pages/auth/ResetPassword.vue'

// profile
import PageProfile from '../pages/profile/Profile.vue'

// license
import PageLicense from '../pages/license/Index.vue'

// Territory Virtual
import PageTerritoryVirtualIndex from '../pages/territory-virtual/Index.vue'
import PageTerritoryVirtualForm from '../pages/territory-virtual/Form.vue'
import PageTerritoryVirtualDetail from '../pages/territory-virtual/Detail.vue'
import PageTerritoryVirtualDetailNotification from '../pages/territory-virtual/DetailNotification.vue'

// media
import PageMedia from '../pages/media/Index.vue'
import PageFaceRecognition from '../pages/media/face-recognition.vue'

// Notification
import PageNotification from '../pages/notification/Index.vue'

// Monitoring
import PageMonitoringLog from '../pages/monitoring/Index.vue'

import PageUsersLog from '../pages/userslog/Index.vue'

// Monitoring
import PageName from '../pages/name/Index.vue'

// univ name
import PageUnivName from '../pages/university/Index.vue'

// Devices
// import PageDevices from '../pages/devices/Index.vue'
// import PageDeviceDetail from '../pages/devices/Detail.vue'
// import PageDeviceCreate from '../pages/devices/Create.vue'

// tactical device
import PageTacticalDevicesIndex from '../pages/tactical-devices/Index.vue'
import PageTacticalDevicesForm from '../pages/tactical-devices/Form.vue'
import PageTacticalDevicesDetail from '../pages/tactical-devices/Detail.vue'

// clients
import PageClientsIndex from '../pages/clients/Index.vue'
import PageClientsForm from '../pages/clients/Form.vue'

// Modules
import PageModulesIndex from '../pages/modules/Index.vue'
import PageModulesForm from '../pages/modules/Form.vue'

// Function Modules
import PageFunctionIndex from '../pages/function/Index.vue'
import PageFunctionForm from '../pages/function/Form.vue'

// Roles
import PageRolesIndex from '../pages/roles/Index.vue'
import PageRolesForm from '../pages/roles/Form.vue'

// users
import PageUsersIndex from '../pages/users/Index.vue'
import PageUsersForm from '../pages/users/Form.vue'
import PageUsersLogActivity from '../pages/users/LogActivity.vue'

// acl
import PageAclForm from '../pages/acl/Form.vue'

// users
import PageCaseManagementIndex from '../pages/casemanagement/Index.vue'
import PageCaseManagementForm from '../pages/casemanagement/Form.vue'

// target
import PageTargetIndex from '../pages/target/Index.vue'
import PageTargetForm from '../pages/target/Form.vue'
import PageTargetDetail from '../pages/target/Detail.vue'
import PageTargetDetailHome from '../pages/target/detail/Home.vue'

// multi tacking / target
import PageMultiTrackingIndex from '../pages/multi-tracking/Index.vue'
import PageMultiTrackingForm from '../pages/multi-tracking/Form.vue'
import PageMultiTrackingMeetingPoint from '../pages/multi-tracking/MeetingPoint.vue'
import PageMultiTrackingDetail from '../pages/multi-tracking/Detail.vue'

// errors
import PageNotFound from '../pages/errors/NotFound.vue'
import PageForbidden from '../pages/errors/Forbidden.vue'

// Tracking History
import PageTrackingHistory from '../pages/tracking-history/Index.vue'

// upload app
import PageUploadApp from '../pages/upload-app/Form.vue'

Vue.use(Router);

let listMenu = [
    {
        path: 'recent-location',
        name: 'recent-location',
        component: PageResultRecentLocation
    },
    {
        path: 'application-usage',
        name: 'application-usage',
        component: PageResultApplicationUsage
    },
    {
        path: 'history-location',
        name: 'history-location',
        component: PageResultHistoryLocation
    },
    {
        path: 'history-browsing',
        name: 'history-browsing',
        component: PageResultHistoryBrowsing
    },
    {
        path: 'device-history',
        name: 'device-history',
        component: PageResultDeviceHistory
    },
    {
        path: 'tethered-devices',
        name: 'tethered-devices',
        component: PageResultTetheredDevices
    },
    {
        path: 'possible-location',
        name: 'possible-location',
        component: PageResultPossibleLocation
    },
    {
        path: 'aerial-log',
        name: 'aerial-log',
        component: PageResultAerialLog
    },
    {
        path: 'signal-status',
        name: 'signal-status',
        component: PageResultSignalStatus
    },
    {
        path: 'profile',
        name: 'profile',
        component: PageResultProfile
    },
    {
        path: 'prediction-nickname',
        name: 'prediction-nickname',
        component: PageResultPredictionNickname
    },
    {
        path: 'vehicles',
        name: 'vehicles',
        component: PageResultVehicles
    },
    {
        path: 'marketplace',
        name: 'marketplace',
        component: PageResultMarketplace
    },
    {
        path: 'travel-history',
        name: 'travel-history',
        // component: PageResultHealthAlert
        component: PageTravelHistoryResult
    },
    {
        path: 'travel',
        name: 'travel',
        component: PageResultTravel
    },
    {
        path: 'etilang',
        name: 'etilang',
        component: PageResultEtilang
    },
    {
        path: 'bank-account',
        name: 'bank-account',
        component: PageResultBankAccount
    },
    {
        path: 'personal-identity',
        name: 'personal-identity',
        component: PageResultPersonalIdentity
    },
    // ----------------------------------------------------
    // {
    //     path: 'overall',
    //     name: 'result-overall',
    //     component: PageResultOverall
    // },
    // {
    //     path: 'history-app',
    //     name: 'history-app',
    //     component: PageResultHistoryApp
    // },
];

// let resultMenu = listMenu;
let resultMenu = [];
let targetDetailMenu = [
    {
        path: 'home',
        name: 'PageTargetDetailHome',
        component: PageTargetDetailHome
    }
];

for (var i = 0; i < listMenu.length; i++) {
    // resultMenu.push(listMenu[i]);
    resultMenu.push({
        path: listMenu[i].path,
        name: 'result-' + listMenu[i].name,
        component: (i === 0 && process.env.VUE_APP_ASTRO === 'true' ? PageResultRecentLocationAstro : listMenu[i].component)
    });

    targetDetailMenu.push({
        path: listMenu[i].path,
        name: 'target-detail-' + listMenu[i].name,
        component: (i === 0 && process.env.VUE_APP_ASTRO === 'true' ? PageResultRecentLocationAstro : listMenu[i].component)
    });
}

export default new Router({
    mode: 'history',
    linkExactActiveClass: 'is-active',
    // scrollBehavior: function(to, from, savedPosition) {
    scrollBehavior: function(to) {
        if (to.hash) {
            return {selector: to.hash}
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        // auth
        {
            path: '/login',
            name: 'pageLogin',
            component: PageLogin,
        },
        {
            path: '/forgot-password',
            name: 'pageForgotPassword',
            component: PageForgotPassword,
        },
        {
            path: '/reset-password',
            name: 'pageResetPassword',
            component: PageResetPassword,
        },
        {
            path:'/',
            name: 'PageDashboard',
            component: PageDashboard,
            meta: {
                requiresAuth: true
            }
        },

        // license
        {
            path: '/license',
            name: 'PageLicense',
            component: PageLicense
        },

        // case management
        {
            path:'/case-management',
            name: 'PageCaseManagementIndex',
            component: PageCaseManagementIndex,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/case-management/create',
            name: 'PageCaseManagementCreate',
            component: PageCaseManagementForm,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/case-management/:id/edit',
            name: 'PageCaseManagementEdit',
            component: PageCaseManagementForm,
            meta: {
                requiresAuth: true
            },
        },

        // target
        {
            path:'/target',
            name: 'PageTargetIndex',
            component: PageTargetIndex,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/target/create',
            name: 'PageTargetCreate',
            component: PageTargetForm,
            meta: {
                requiresAuth: true
            },
            props:true,
        },
        {
            path:'/target/:id/edit',
            name: 'PageTargetEdit',
            component: PageTargetForm,
            meta: {
                requiresAuth: true
            },
            props:true,
        },
        {
            path:'/target/:id/detail/:key?',
            name: 'PageTargetDetail',
            component: PageTargetDetail,
            meta: {
                requiresAuth: true
            },
            children: targetDetailMenu
            // children: [
            //     {
            //         path: 'home',
            //         name: 'PageTargetDetailHome',
            //         component: PageTargetDetailHome
            //     },
            // ]
        },

        // multi tracking / target
        {
            path:'/multi-tracking',
            name: 'PageMultiTrackingIndex',
            component: PageMultiTrackingIndex,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/multi-tracking/create',
            name: 'PageMultiTrackingCreate',
            component: PageMultiTrackingForm,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/multi-tracking/:id/edit',
            name: 'PageMultiTrackingEdit',
            component: PageMultiTrackingForm,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/multi-tracking/:id/meeting-point/:idMeet',
            name: 'PageMultiTrackingMeetingPoint',
            component: PageMultiTrackingMeetingPoint,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/multi-tracking/:id/detail/:key?',
            name: 'PageMultiTrackingDetail',
            component: PageMultiTrackingDetail,
            meta: {
                requiresAuth: true
            },
        },

        // Territory Virtual
        {
            path:'/territory-virtual',
            name: 'PageTerritoryVirtualIndex',
            component: PageTerritoryVirtualIndex,
            meta: {
                requiresAuth: true
            }
        },
        {
            path:'/territory-virtual/create',
            name: 'PageTerritoryVirtualCreate',
            component: PageTerritoryVirtualForm,
            meta: {
                requiresAuth: true
            }
        },
        {
            path:'/territory-virtual/:id/edit',
            name: 'PageTerritoryVirtualEdit',
            component: PageTerritoryVirtualForm,
            meta: {
                requiresAuth: true
            }
        },
        {
            path:'/territory-virtual/:id/detail',
            name: 'PageTerritoryVirtualDetail',
            component: PageTerritoryVirtualDetail,
            meta: {
                requiresAuth: true
            }
        },
        {
            path:'/territory-virtual/:id/detail/notification/:target_id/:msisdn',
            name: 'PageTerritoryVirtualDetailNotification',
            component: PageTerritoryVirtualDetailNotification,
            meta: {
                requiresAuth: true
            }
        },

        {
            path:'/notification',
            name: 'PageNotification',
            component: PageNotification,
            meta: {
                requiresAuth: true
            }
        },
        
        //Devices
        {
            path:'/tactical-devices',
            name: 'PageTacticalDevicesIndex',
            component: PageTacticalDevicesIndex,
            meta: {
                requiresAuth: true
            }
        },
        {
            path:'/tactical-devices/create',
            name: 'PageTacticalDevicesCreate',
            component: PageTacticalDevicesForm,
            meta: {
                requiresAuth: true
            }
        },
        {
            path:'/tactical-devices/:id/edit',
            name: 'PageTacticalDevicesEdit',
            component: PageTacticalDevicesForm,
            meta: {
                requiresAuth: true
            }
        },
        {
            path:'/tactical-devices/:id/detail',
            name: 'PageTacticalDevicesDetail',
            component: PageTacticalDevicesDetail,
            meta: {
                requiresAuth: true
            }
        },

        // monitoring
        {
            path:'/monitoring',
            name: 'PageMonitoringLog',
            component: PageMonitoringLog,
            meta: {
                requiresAuth: true
            }
        },

        // users log
        {
            path:'/users-log',
            name: 'PageUsersLog',
            component: PageUsersLog,
            meta: {
                requiresAuth: true
            }
        },

        // Name
        {
            path:'/search-by-name/:key?',
            name: 'PageName',
            component: PageName,
            meta: {
                requiresAuth: true
            }
        },

        // Univ Name
        {
            path:'/search-univ-name/:key?',
            name: 'PageUnivName',
            component: PageUnivName,
            meta: {
                requiresAuth: true
            }
        },

        // result
        {
            path:'/result/:key?',
            // path:'/result',
            name: 'PageResult',
            // component: PageWrapper,
            component: PageResult,
            meta: {
                requiresAuth: true
            },
            children: resultMenu
        },

        // component (template)
        {
            path:'/components',
            name: 'components',
            component: PageComponents,
            meta: {
                requiresAuth: true
            }
        },

        // vehicles (template)
        {
            path:'/vehicles/:key?',
            name: 'vehicles',
            component: PageVehicles,
            meta: {
                requiresAuth: true
            }
        },

        // profile
        {
            path: '/profile',
            name: 'PageProfile',
            component: PageProfile,
            meta: {
                requiresAuth: true
            }
        },
        
        // media / fr
        {
            path: '/media',
            name: 'PageMediaPhoto',
            component: PageMedia,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/face-recognition',
            name: 'PageFaceRecognition',
            component: PageFaceRecognition,
            meta: {
                requiresAuth: true
            }
        },

        // clients
        {
            path:'/clients',
            name: 'PageClientsIndex',
            component: PageClientsIndex,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/clients/create',
            name: 'PageClientsCreate',
            component: PageClientsForm,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/clients/:id/edit',
            name: 'PageClientsEdit',
            component: PageClientsForm,
            meta: {
                requiresAuth: true
            },
        },

        // modules
        {
            path:'/modules',
            name: 'PageModulesIndex',
            component: PageModulesIndex,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/modules/create',
            name: 'PageModulesCreate',
            component: PageModulesForm,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/modules/:id/edit',
            name: 'PageModulesEdit',
            component: PageModulesForm,
            meta: {
                requiresAuth: true
            },
        },

        // function modules
        {
            path:'/function',
            name: 'PageFunctionIndex',
            component: PageFunctionIndex,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/function/create',
            name: 'PageFunctionCreate',
            component: PageFunctionForm,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/function/:id/edit',
            name: 'PageFunctionEdit',
            component: PageFunctionForm,
            meta: {
                requiresAuth: true
            },
        },

        // roles
        {
            path:'/roles',
            name: 'PageRolesIndex',
            component: PageRolesIndex,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/roles/create',
            name: 'PageRolesCreate',
            component: PageRolesForm,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/roles/:id/edit',
            name: 'PageRolesEdit',
            component: PageRolesForm,
            meta: {
                requiresAuth: true
            },
        },

        // users
        {
            path:'/users',
            name: 'PageUsersIndex',
            component: PageUsersIndex,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/users/create',
            name: 'PageUsersCreate',
            component: PageUsersForm,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/users/:id/edit',
            name: 'PageUsersEdit',
            component: PageUsersForm,
            meta: {
                requiresAuth: true
            },
        },
        {
            path:'/users/:id/log-activity',
            name: 'PageUsersLogActivity',
            component: PageUsersLogActivity,
            meta: {
                requiresAuth: true
            },
        },

        // acl
        {
            path:'/acl',
            name: 'PageAcl',
            component: PageAclForm,
            meta: {
                requiresAuth: true
            },
        },

        // errors page
        // forbidden
        {
            path: '/errors/forbidden',
            name: 'PageForbidden',
            component: PageForbidden,
        },

        // not found
        {
            path: '*',
            name: 'PageNotFound',
            component: PageNotFound,
        },

        // tracking-history
        {
            path:'/tracking-history',
            name: 'PageTrackingHistory',
            component: PageTrackingHistory,
            meta: {
                requiresAuth: true
            }
        },

        // upload-app
        {
            path:'/upload-app',
            name: 'PageUploadApp',
            component: PageUploadApp,
            meta: {
                requiresAuth: true
            }
        },
    ]
});
